module.exports = __webpack_public_path__ + "static/media/icon_msg.2006550d.png";